import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')

const privacySettings = document.querySelector('[data-role="privacy-settings"]')
if (privacySettings) {
  privacySettings.addEventListener('click', () => window._privacy.openModal({ purposeToHighlight: 'personalisation' }))
}
